/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let notesApiURL = root.notesApiUrl.link;
let notesSharedApiURL = root.notesSharedApiUrl.link;
let notesSharedinGroupApiUrl = root.notesSharedinGroupApiUrl.link;
let notesReadStatusApiUrl = root.notesReadStatusApiUrl.link;
let notesSearchApiUrl = root.notesSearchApiUrl.link;
let getSharedNotesApiUrl = root.getSharedNotesApiUrl.link;

export default {
  state: {
    getAllNotesListState:{},
    getAllSharedNotesListState:{}
  },
  mutations: {
    getAllNotesListMutation(state, value) {
      Vue.set(state, 'getAllNotesListState', value);
    },
    getAllSharedNotesListMutation(state, value) {
      Vue.set(state, 'getAllSharedNotesListState', value);
    },
  },
  actions: {
    // Notes Search Api Status Api
    notesSearchBarAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(notesSearchApiUrl + '?search=' + payload.query).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Notes Read Status Api
    isReadNotestStatusFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(notesReadStatusApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Notes Shared In Group Details Api
    createNotesSharedInGroupFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(notesSharedinGroupApiUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All Notes Api
    getAllNotesListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(notesApiURL, payload).then(res => {
              context.commit('getAllNotesListMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Notes Details Api
    createNewNotesDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(notesApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Notes Details Api
    updateNewNotesDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(notesApiURL + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Notes Details By Id Api
    getNotesDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(notesApiURL + payload.id + '/', payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Remove Notes Details Api
    deleteNewNotesDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(notesApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Notes Shared Api
    newNotesSharedFun(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post(notesSharedApiURL, payload).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
      })
   },
   // Get All Shared Notes Api
   getAllSharedNotesListFun(context, payload) {
       return new Promise((resolve, reject) => {
           axios.get(getSharedNotesApiUrl, payload).then(res => {
             context.commit('getAllSharedNotesListMutation', res.data);
             resolve(res);
           }).catch(err => {
             reject(err);
           })
       })
   },
  },
  getters: {
    getAllNotesListGetters: state => state.getAllNotesListState,
    getAllSharedNotesListGetters: state => state.getAllSharedNotesListState
  }
}